import { render, staticRenderFns } from "./Wp_limit_price_model.vue?vue&type=template&id=b627ec74&scoped=true&"
import script from "./Wp_limit_price_model.vue?vue&type=script&lang=js&"
export * from "./Wp_limit_price_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b627ec74",
  null
  
)

export default component.exports